module.exports = __webpack_public_path__ + "static/media/bg15.1d547621.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg15.jpg
// module id = 3963
// module chunks = 0